/**
 * A Result is either { ok: true, value } or { ok: false, error }.
 * It is the typed version of returning an error code in C: callers must check `ok`
 * before they can touch `value`, and the compiler enforces it.
 */

export type ErrorCode =
  | "invalid_input"
  | "not_found"
  | "already_exists"
  | "duplicate_name"
  | "in_use"
  | "cannot_undo"
  | "forbidden";

export interface DomainError {
  code: ErrorCode;
  message: string;
}

export type Result<T> = { ok: true; value: T } | { ok: false; error: DomainError };

export function ok<T>(value: T): Result<T> {
  return { ok: true, value };
}

export function err<T = never>(code: ErrorCode, message: string): Result<T> {
  return { ok: false, error: { code, message } };
}
